module.exports = __webpack_public_path__ + "img/card.7be2206e.png";